<template>
  <div class="tabs-cmp">
    <v-row class="justify-space-between d-flex" style="flex-direction: row;">
      <v-tabs style="max-width: fit-content;" v-model="activeTab" background-color="var(--v-alternativeBtnBackground-base)"
        class="rounded-lg custom-tabs px-1" height="36">
        <v-tab v-for="(tab, index) in tabs" :key="index" :to="buildPath(tab)" class="tab-button">
          <v-icon small class="mr-2">fa-regular {{ tab.icon }}</v-icon>
          {{ tab.name }}
        </v-tab>
      </v-tabs>
      <!-- <v-chip outlined @click="newTrades"><v-icon left>fa-regular fa-plus</v-icon>{{
        $t("createTrade") }}</v-chip> -->
    </v-row>

    <div class="current-tab mt-6">
      <RouterView />
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    newTrades: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    activeTab: 'tab-1',
  }),
  methods: {
    buildPath(tab) {
      const queryParams = this.$route.fullPath.split("?")[1];
      return `/${tab.base}/${tab.path}${queryParams ? '?' + queryParams : ''}`;
    }
  },
  created() {
    // Select first tab by default
    if (this.tabs && this.tabs.length > 0) {
      const firstTab = this.tabs[0];
      this.$router.replace(`/${firstTab.base}/${firstTab.path}`);
      this.activeTab = 0;
    }
  },
  mounted() {
    // Set active tab based on current route
    const currentPath = this.$route.path.split('/')[2]; // Get current path segment
    const tabIndex = this.tabs.findIndex(tab => tab.path === currentPath);
    if (tabIndex >= 0) {
      this.activeTab = tabIndex;
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs-cmp {
  .v-tabs {
    border-radius: 8px;
    overflow: hidden;

    ::v-deep {

      // Remove bottom bar
      .v-tabs-bar {
        border-bottom: none !important;

        &::before {
          display: none !important;
        }
      }

      // Remove slider
      .v-tabs-slider {
        display: none !important;
      }

      .v-slide-group__wrapper{
        background-color: var(--v-lightGray-base);
        border-radius: 8px;
      }

      .v-tab {
        text-transform: none;
        font-family: 'Avenir', sans-serif;
        font-size: 14px;
        color: var(--v-darkGray-base) !important;
        min-height: 32px !important;
        margin: 0px;
        border-radius: 8px;
        padding: 0 20px !important;
        text-decoration: none;

        &:not(.v-tab--active) span {
          color: inherit !important;
        }

        &--active {
          background-color: var(--v-mainBtnBackground-base);
          color: #F8F8F8 !important;
        }

        .v-icon {
          color: inherit !important;
        }

        &.v-tab--active {
          background-color: var(--v-mainGreen-base) !important;
          color: #F8F8F8 !important;
          border-radius: 8px;
          border-bottom: none !important;

          span {
            color: inherit !important;
          }
        }

        &::before,
        &::after {
          opacity: 0 !important;
          background-color: transparent !important;
          display: none !important;
        }
      }
    }
  }

  @media (max-width: 768px) {
    margin-top: 15px;

    .v-tabs {
      width: fit-content;
      margin: 0 auto;
    }
  }
}
</style>
